import { MutableRefObject } from 'react';
import { Box } from '@mui/material';
import { getEmbedUrl } from '../../../helpers/marketing';

export interface TemplateEmbedData {
  id: number;
  url: string;
}

interface Props {
  embedTemplate: TemplateEmbedData;
  iframeRef: MutableRefObject<HTMLIFrameElement | null>;
}

function TemplateEmbed({ embedTemplate, iframeRef }: Props) {
  return (
    <Box width="100%" height="100%" flex={1} position="relative">
      <iframe
        ref={iframeRef}
        src={getEmbedUrl(embedTemplate.url)}
        width="100%"
        height="100%"
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 100000,
        }}
        frameBorder="0"
        title="email-template"
      />
    </Box>
  );
}

export default TemplateEmbed;
